import './lib/native-type-extensions/array';
import { defaultArrayCompare, reverseArrayCompare } from './lib/native-type-extensions/array';
import './lib/native-type-extensions/string';

export { defaultArrayCompare, reverseArrayCompare };
